import { Image, Modal, NavBar, Picker, Toast } from 'antd-mobile-v5'
import { useHistory, useLocation } from 'react-router-dom'
import React, { useEffect, useState } from 'react'
import { CertsList } from '../CertsList/CertsList'
import { isMainlandPro, isMainlandUser } from '../../utils/user'
import AgreementPopup from '../../components/common/AgreementPopup'
import BottomNav from '../HomeNav/BottomNav'
import EcardsListFooter from '../../components/EcardsList/EcardsListFooter'
import UserHeader from '../UserHeader/UserHeader'
import { useIntl } from 'react-intl'
import { ClosableToast } from '../common/ClosableToast'
import { UClick } from '../common/utils'
import { useGetChinaCities, useGetChinaProvinces } from '../FormTools/SelectRegion'

import { useAutoRenew, useCheckAgreement, useGetVisitStatus, useMailingAddress } from '../../services/hooks'

export default function EcardsList({ ecards, nextCerts, profile, userInfo }) {
  const history = useHistory()
  const { data: agreements } = useCheckAgreement()
  const [visible, setVisible] = useState(false)
  const { pathname } = useLocation()
  const { formatMessage } = useIntl()
  const { show: showAutoRenewPopup } = ClosableToast({ content: '现在您可在"我的 → 教练服务"中签署会员自动更新。' })
  const [cityModalVisible, setCityModalVisible] = useState(false)
  const [provinceId, setProvinceId] = useState('')
  const [cityId, setCityId] = useState('')
  const [selectedCityInfo, setSelectedCityInfo] = useState(null)
  const { show: showSuccessToast } = ClosableToast({ content: '地址信息已更新' })

  const { data: chinaProvinces, loading: provincesLoading } = useGetChinaProvinces()
  const { data: chinaCities, loading: citiesLoading } = useGetChinaCities(provinceId)

  const { run: updateMailingAddress } = useMailingAddress()
  const {
    run: checkVisitStatus,
    loading: checkLoading,
    data: visitStatus,
  } = useGetVisitStatus({
    cacheKey: 'visitStatus_SessionCache',
    cacheTime: -1,
    staleTime: -1,
  })

  useEffect(() => {
    UClick('EcardsPage1')
    if (!visitStatus) {
      checkVisitStatus()
    }
  }, [])

  useEffect(() => {
    if (
      pathname === '/certs' &&
      profile?.shippingAddress &&
      profile?.shippingAddress.countryId === 51 &&
      !profile.shippingAddress.city
    ) {
      if (profile.shippingAddress.stateId && chinaProvinces) {
        setProvinceId(profile.shippingAddress.stateId)
      }
      setCityModalVisible(true)
    }
  }, [pathname, profile, chinaProvinces])

  const handleProvinceChange = (value) => {
    setProvinceId(value)
    setCityId('')
    setSelectedCityInfo(null)
  }

  const handleCityChange = (value) => {
    setCityId(value)
    const city = chinaCities.find((c) => c.value === parseInt(value))
    if (city) {
      setSelectedCityInfo(city)
    }
  }

  const handleSaveCity = async () => {
    if (!selectedCityInfo) {
      Toast.show({
        content: formatMessage({ id: 'form-city-hint' }),
      })
      return
    }

    const addressData = {
      countryId: profile.shippingAddress.countryId,
      city: selectedCityInfo.englishName,
      stateId: provinceId,
      postalCode: profile.shippingAddress.postalCode,
      addressLine1: profile.shippingAddress.addressLine1,
    }

    try {
      updateMailingAddress(addressData)
      showSuccessToast()
      setCityModalVisible(false)
    } catch (error) {
      Toast.show({
        content: '地址信息更新失败，请重试',
      })
    }
  }

  useAutoRenew({
    onSuccess: (data) => {
      if (!isMainlandPro(profile)) {
        return
      }
      if (!data.bind) {
        showAutoRenewPopup()
      }
    },
  })

  useEffect(() => {
    const showAgreements = agreements?.filter((agree) => !agree.agree).length > 0
    if (agreements) setVisible(showAgreements)
  }, [agreements])

  if (checkLoading) return null

  return (
    <>
      {agreements && <AgreementPopup agreements={agreements} visible={visible} setVisible={setVisible} />}
      {pathname === '/ecards' && (
        <NavBar
          back={formatMessage({ id: 'common-back' })}
          onBack={() => (window.location.href = 'https://club.padi.com.cn/pages/home/home')}
        ></NavBar>
      )}
      <UserHeader ecards={ecards} userInfo={userInfo} profile={profile} />
      <CertsList ecards={ecards} userInfo={userInfo} visitStatus={visitStatus} />
      <EcardsListFooter profile={profile} nextCerts={nextCerts} ecards={ecards} />
      <Image
        style={{
          position: 'fixed',
          bottom: '200px',
          right: '0',
          width: '65px',
          zIndex: 200,
        }}
        onClick={() => history.push('/campaign')}
        src={require('../../assets/images/common/campaign-icon.png')}
      />
      <BottomNav isMainlandUser={isMainlandUser(userInfo)} />

      <Modal
        visible={cityModalVisible}
        onClose={() => setCityModalVisible(false)}
        title={formatMessage({ id: 'common-address-detail' })}
        footer={[
          {
            text: formatMessage({ id: 'common-cancel' }),
            onPress: () => setCityModalVisible(false),
          },
          {
            text: formatMessage({ id: 'addressForm-save' }),
            onPress: handleSaveCity,
            positive: true,
            disabled: !selectedCityInfo,
          },
        ]}
        actions={[
          {
            key: 'confirm',
            text: formatMessage({ id: 'addressForm-save' }),
            primary: true,
            onClick: handleSaveCity,
          },
          {
            key: 'cancel',
            text: formatMessage({ id: 'common-cancel' }),
            onClick: () => setCityModalVisible(false),
          },
        ]}
        content={
          <div style={{ padding: '16px 0' }}>
            <div style={{ marginBottom: '16px' }}>系统缺少您的地理位置信息，请更新：</div>
            <div style={{ marginBottom: '24px' }}>
              <div style={{ marginBottom: '8px', fontSize: '14px' }}>{formatMessage({ id: 'common-Province' })}</div>
              <div
                style={{
                  padding: '12px',
                  border: '1px solid #d9d9d9',
                  borderRadius: '4px',
                  backgroundColor: provincesLoading ? '#f5f5f5' : '#fff',
                  cursor: provincesLoading ? 'not-allowed' : 'pointer',
                }}
                onClick={() => {
                  if (provincesLoading) return
                  Picker.prompt({
                    title: formatMessage({ id: 'form-stateid-hint' }),
                    columns: [chinaProvinces || []],
                  }).then((value) => {
                    if (value) {
                      const selectedValue = value[0]
                      handleProvinceChange(selectedValue)
                    }
                  })
                }}
              >
                {provincesLoading
                  ? formatMessage({ id: 'common-loading' })
                  : chinaProvinces?.find((p) => p.value === provinceId)?.label ||
                    formatMessage({ id: 'form-stateid-hint' })}
              </div>
            </div>

            <div>
              <div style={{ marginBottom: '8px', fontSize: '14px' }}>{formatMessage({ id: 'common-City' })}</div>
              <div
                style={{
                  padding: '12px',
                  border: '1px solid #d9d9d9',
                  borderRadius: '4px',
                  backgroundColor: citiesLoading || !provinceId ? '#f5f5f5' : '#fff',
                  cursor: citiesLoading || !provinceId ? 'not-allowed' : 'pointer',
                }}
                onClick={() => {
                  if (citiesLoading || !provinceId) return
                  Picker.prompt({
                    title: formatMessage({ id: 'form-city-hint' }),
                    columns: [chinaCities || []],
                  }).then((value) => {
                    if (value) {
                      const selectedValue = value[0]
                      handleCityChange(selectedValue)
                    }
                  })
                }}
              >
                {citiesLoading
                  ? formatMessage({ id: 'common-loading' })
                  : !provinceId
                    ? formatMessage({ id: 'form-stateid-hint' })
                    : chinaCities?.find((c) => c.value === parseInt(cityId))?.label ||
                      formatMessage({ id: 'form-city-hint' })}
              </div>
            </div>
          </div>
        }
      />
    </>
  )
}
